










































import { Component, Vue, Prop } from "vue-property-decorator";
import { State, Action } from 'vuex-class';

/**
 * Mixins
 */
import mixinsAPI from "@/mixins/api-mixins";

/**
 * API
 */
import authenticationAPI from '@/api/authentication';

/**
 * Types
 */
import { ActivateAccountRequest } from '@/api/authentication';

/**
 * Page d'activation de compte.
 */
@Component({ mixins: [mixinsAPI] })
export default class ActivateAccountPage extends Vue {
	/** VueX - Snackbar */
	@Action('openInfo', { namespace: 'snackbar' }) openInfo: any;
	@Action('openError', { namespace: 'snackbar' }) openError: any;

	/** Attributs */
	isLoading = false;
	form = new ActivateAccountRequest();

	/** Méthodes */
	async handleSubmit() {
		this.isLoading = true;
		try {
			this.form.token = this.$route.query.token as string;
			await authenticationAPI.activateAccount(this.form);
			this.openInfo(this.$t('snackbar.success'));
			this.$router.push(`/`);
		}
		catch (err) {
			(this as any).handleAPIError(err);

		}
		this.isLoading = false;
	}
}
